const $ = jQuery.noConflict();

'use strict';
const UploadFile = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.fileUpload();
	},

	fileUpload: () => {
		$('.js-file-input').on('change', function() {
			updateList($(this));
		});

		function updateList(input) {
			const output = input.closest('.js-upload-wrap').find('.js-file-list');
			const files = input[0].files;
			for (let i = 0; i < files.length; ++i) {
				const file = files[i];
				if (isAllowedFileType(file)) {
					output.append('<li> <span class="upload-doc-icon"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20" fill="none"><path d="M9.41667 1.66699H11.6667C13.0668 1.66699 13.7669 1.66699 14.3016 1.93948C14.772 2.17916 15.1545 2.56161 15.3942 3.03202C15.6667 3.5668 15.6667 4.26686 15.6667 5.66699V14.3337C15.6667 15.7338 15.6667 16.4339 15.3942 16.9686C15.1545 17.439 14.772 17.8215 14.3016 18.0612C13.7669 18.3337 13.0668 18.3337 11.6667 18.3337H6.33333C4.9332 18.3337 4.23314 18.3337 3.69836 18.0612C3.22795 17.8215 2.8455 17.439 2.60582 16.9686C2.33333 16.4339 2.33333 15.7338 2.33333 14.3337V13.7503M12.3333 10.8337H8.58333M12.3333 7.50033H9.41667M12.3333 14.167H5.66667M4 8.33366V3.75033C4 3.05997 4.55964 2.50033 5.25 2.50033C5.94036 2.50033 6.5 3.05997 6.5 3.75033V8.33366C6.5 9.71437 5.38071 10.8337 4 10.8337C2.61929 10.8337 1.5 9.71437 1.5 8.33366V5.00033" stroke="#154877" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' + '<span class="doc-text">' + file.name + '</span>' + '<span class="js-remove-doc remove-doc"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor"><path d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg></span>' + '</li>');
				} else {
					const errorMessage = $('<span class="file-error-message">Only JPEG and PDF accepted</span>');
					$('.js-custom-file').append(errorMessage);
					setTimeout(function() {
						errorMessage.remove();
					}, 5000);
				}
			}
		}

		function isAllowedFileType(file) {
			const allowedTypes = ['image/jpeg', 'application/pdf'];
			return allowedTypes.includes(file.type);
		}

		$(document).on('click', '.js-remove-doc', function() {
			$(this).parent().remove();
		});
	}
};

export default UploadFile;